import React from "react";

import { useIntl } from "react-intl";

import { getResourceProfile } from "Constants/constants";
import { Link } from "ds/Button";
import ServiceAction from "src/organization/pages/project/environment/metrics/containers/Service/ServiceAction";
import ChartInfo from "src/organization/pages/project/environment/metrics/http/components/ChartInfo";

import {
  HeaderContainer,
  TitleWrapper,
  ContainerProfile,
  ProfileType,
  InfoWrapper
} from "./ServiceMetrics.styles";

const MetricsHeader = ({ service }) => {
  const profile = getResourceProfile(service?.container_profile);

  const intl = useIntl();
  return (
    <HeaderContainer>
      <TitleWrapper>
        <ContainerProfile>
          {intl.formatMessage({ id: "container_profile" })}
        </ContainerProfile>
        <ProfileType>{profile}</ProfileType>
        <InfoWrapper>
          <ChartInfo
            title={intl.formatMessage({ id: "container_profiles" })}
            description={intl.formatMessage({
              id: "container_profile_description"
            })}
            link={
              <Link
                analyticId="learn_more"
                href={intl.formatMessage({
                  id: "links.documentation.container_profiles"
                })}
              >
                {intl.formatMessage({ id: "learn_more" })}
              </Link>
            }
          />
        </InfoWrapper>
      </TitleWrapper>
      <ServiceAction service={service} />
    </HeaderContainer>
  );
};

export default MetricsHeader;
